import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TestDisplayComponent } from './components/test-display/test-display.component';
import { QuestionnaireComponent } from './components/questionnaire/questionnaire.component';
import { ForcedChoiceDisplayComponent } from './components/forced-choice-display/forced-choice-display.component';
import { AppComponent } from './app.component';
import { InstructionsComponent } from './components/instructions/instructions.component';
import { InstructionContainerBgFullComponent } from './components/instruction-container-bg-full/instruction-container-bg-full.component';
import { InstructionContainerBgHalfComponent } from './components/instruction-container-bg-half/instruction-container-bg-half.component';
import { InstructionContainerBgMonoComponent } from './components/instruction-container-bg-mono/instruction-container-bg-mono.component';
import { DisplayComponent } from './components/display/display.component';
import { OverviewComponent } from './components/overview/overview.component';
import { IntermissionComponent } from './components/intermission/intermission.component';
import { MediaDisplayComponent } from './components/media-display/media-display.component';
import { IATDisplayComponent } from './components/iat-display/iat-display.component';

const routes: Routes = [
  {
    path: '',
    component: DisplayComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
